import { forwardRef, ForwardRefRenderFunction } from "react";
//#region types
import { SelfInvoiceCreateFormProps } from "models/propTypes/selfInvoicePropTypes";
import { FormHandles } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { WintFormSetValues } from "models/propTypes/wintFormPropsTypes";
import { InvoiceContentSelectionFormType } from "models/propTypes/invoicePropTypes";
//#endregion
//#region  components
import { ContentSelectionStep } from "components/invoice";
import { useWintForm, useWintWizard, WintForm, WizardFormSectionContainer } from "components/common/wintForms";
import SelfInvoiceFormGeneralSectionWizard from "./sections/generalSectionWizard";
import SelfInvoiceWizardQuickSelection from "./sections/wizardQuickSelection";
import SelfInvoiceWizardFooter from "../actions/wizardFooter";
import useSelfInvoiceFormValidations from "./useValidationSchema";
//#endregion

const SelfInvoiceCreateForm: ForwardRefRenderFunction<FormHandles, SelfInvoiceCreateFormProps> = (props, ref) => {
  const { invoice, reloadInvoice } = props;

  const { getValidationSchema } = useSelfInvoiceFormValidations();

  const { wintFormProps, formState, connect, values, errors, touched, submitted, setValues } =
    useWintForm<InvoiceFormTypes.SelfInvoice>({
      formRef: ref,
      defaultValues: props.defaultValues,
      validationSchema: getValidationSchema(),
      onFormValidationChange: props.onFormValidationChange,
      validateOnMount: true,
      validateOnBlur: true,
      validateOnChange: false,
    });

  const wizard = useWintWizard(formState);

  return (
    <WintForm {...wintFormProps}>
      <SelfInvoiceWizardQuickSelection connect={connect} />
      <WizardFormSectionContainer wizardProps={wizard}>
        <SelfInvoiceFormGeneralSectionWizard
          connect={connect}
          values={values}
          submitted={submitted}
          wizardProps={wizard}
        />
        <ContentSelectionStep
          connect={connect}
          values={values}
          errors={errors}
          touched={touched}
          submitted={submitted}
          wizardProps={wizard}
          setValues={setValues as WintFormSetValues<InvoiceContentSelectionFormType>}
        />
      </WizardFormSectionContainer>
      <SelfInvoiceWizardFooter
        invoiceId={invoice.id!}
        wizardProps={wizard}
        form={formState}
        invoice={invoice}
        reloadInvoice={reloadInvoice}
      />
    </WintForm>
  );
};

export default forwardRef(SelfInvoiceCreateForm);
